import { useEffect, useState, useRef  } from "react";

// import "../../pages/asset-management/channeldetail/CmsChannelDetail.scss";
import "react-datepicker/dist/react-datepicker.css";
import { Asset_search } from "../../api/api";
import Groupicon from "../../assets/svg/Action/videoIcon.svg";
import GroupIconblue from "../../assets/svg/Assetmanagemant/blueIcon.svg";
import closeChip from "../../assets/svg/Assetmanagemant/closeIcon.svg";
import icroundsearch from "../../assets/svg/Assetmanagemant/search.svg";
import { posterimage } from "../../service/commonFunc";
import "../metaData/metastyle.scss";

import ReactHlsPlayer from "react-hls-player";
import { cloudFront_URL } from "../../service/API_URL";
import SearchBar from "../search-bar/searchBar";
import NoData from "../Common/NoData";
import { observer } from "mobx-react";
import appStore from "../../Config/Store/appStore";
import { toJS } from "mobx";

const Videoplayer = observer(({
  closepartition,
  programVideos,
  searchQuerys,
}) => {
 const divRefs = useRef({});
 const containerRef = useRef();

  useEffect(() => {
      // Scroll to the active div on page load
      const activeItem = contentVideos.find(item => videodata?.filename === item?.filename);
      const container = containerRef.current;
      const activeEl = divRefs.current[activeItem?.id];
      if (container && activeEl) {
        const containerWidth = container.offsetWidth;
        const elementLeft = activeEl.offsetLeft;
        const elementWidth = activeEl.offsetWidth;
        const scrollPosition =
          elementLeft - containerWidth / 2 + elementWidth / 2 - 100; // 100px to left of center

        container.scrollTo({
          left: scrollPosition,
          behavior: "smooth",
        });
      }
      
    }, []);
const [videodata, setVideodata] = useState(toJS(appStore.assetSignledata));
  const AssetPartnerDetail = JSON.parse(
    localStorage.getItem("AssetPartnerDetail")
  );
  
  const assetData = JSON.parse(localStorage.getItem("AssetDetail"));
  const Query = searchQuerys;
  const [metadata, setMetadata] = useState( videodata?.metadata);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState(null);
  // const genre = state?.GenreList?.data;
  const [contentVideos , setContentVideos] = useState(programVideos)

 const databymeta = (data) => {
  appStore.setAssetSignledata(toJS(data));
  setVideodata(toJS(data)); // update local state
  setMetadata(data.metadata);
  setHlsUrl(data?.logoPath ? data?.logoPath : data.publishPath ? data.publishPath : data.sourcePath);
};

   
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [programId, setProgramId] = useState("");
  const [hlsUrl, setHlsUrl] = useState(null);

   const setHls = () => {
    if (videodata?.logoPath != null) {
      console.log("yes logoPath is present")
      setHlsUrl( videodata?.logoPath);
    } else if ( videodata?.publishPath != null) {
      setHlsUrl( videodata?.publishPath);
    } else {
      setHlsUrl( videodata?.sourcePath);
    }
    };

  useEffect(() => {
    
    setHls()
  }, []);

  // const [newUrl, setnewUrl] = useState( videodata?.sourcePath);
  const prefix = cloudFront_URL;

  // Remove the s3://dev-runn part
  const urlWithoutPrefix = hlsUrl?.replace("s3://dev-runn/", "");

  // Add the dynamic prefix
  const newUrl = `${prefix}${urlWithoutPrefix ? urlWithoutPrefix : null}`;

  const getFileTypeFromUrl = (url) => {
    if (url) {
      const extension = url.split(".").pop().toLowerCase();
      if (extension === "m3u8") {
        return "HLS";
      } else {
        return "OTHER";
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.length >= 3 || e.length < 1) {
      AssetSearchPlayer(e);
    }
  };
  const AssetSearchPlayer = async (searchQuery) => {
    const data = {
      id: AssetPartnerDetail?.id,
      query: searchQuery,
    };
    setSearchQuery(data.query);
    console.log("searchbar", searchQuery,data)
    const partnerDataSearch = await Asset_search(data);

    setSearchData(partnerDataSearch.data);
    console.log("searchbar", partnerDataSearch.data,searchData)
    setContentVideos(partnerDataSearch.data.programs
)
  };
  // useEffect()

  return (
    <div className="row">
      <div className="breadcrumbs">
        <ul>
          <li>
            <a href="/asset">Asset Management</a>
          </li>
          <li className="active">
            <a href="/CmsChannelDetail">{AssetPartnerDetail?.name}</a>
          </li>
          {/* <li className="active">Player</li> */}
        </ul>
      </div>

      <div className="video-container">
        <div className="video-title">
          { videodata?.metadata == null
            ?  videodata?.filename
            :  videodata?.metadata?.title}
          <span className="small-grey-text" style={{ marginLeft: "16px" }}>
            {" "}
            { videodata?.metadata == null
              ? null
              : "(" +  videodata?.filename + ")"}
          </span>
        </div>

        <div
          className="cross-container border-0"
          style={{ marginLeft: "auto" }}
          //   onDoubleClickCapture={() => handleDoubleClick()}
          onClick={() => closepartition()}
        >
          <img
            src={closeChip}
            className="image"
            width={36}
            height={36}
            alt="close"
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <div className="videoPlayerContainer">
        {/* Conditionally render HLS player for HLS files */}
        {getFileTypeFromUrl(hlsUrl) === "HLS" ? (
          <ReactHlsPlayer
            autoPlay={true}
            src={newUrl}
            controls={true}
            muted
            loop
            className="w-full h-full object-cover"
            style={{
              borderRadius: "10px",
              height: "55vh",
              aspectRatio: "18 / 9",
              objectFit:"cover"
            }}
            // style={{ maxWidth: "70%", maxHeight: "56.25vw", borderRadius:"10px"}} // 16:9 aspect ratio
          />
        ) : (
          <video
            className="mp4player"
            id="video"
            class="w-full h-full object-cover"
            controls
            autoPlay
            src={newUrl}
            style={{
              borderRadius: "10px",
              height: "55vh",
              aspectRatio: "18 / 9",
              objectFit:"cover"
            }}
          ></video>
        )}
      </div>

      <div className="allvideos">
        <div className="videosheading">
          <h3 className=""> Videos </h3>
          <SearchBar
            placeholder="Search using file name..."
            searchQuery={searchQuery}
            searchValue={Query}
            searchOutput={handleKeyPress}
            keyEnter={false}
            icon={icroundsearch}
          />
        </div>
        <div className="video-channel-list meta alllist" ref={containerRef}>
          <div className="horizontalscrollbar" >
           
             { contentVideos.length > 0 ? <>
                {contentVideos.map((data, index) => {
                let image = posterimage(data);

                return ( <div
                    className={`${videodata?.filename === data?.filename ? "selected-block": ""} block m-auto`}
                    onClick={()=>{databymeta(data)}}
                    ref={el => (divRefs.current[data.id] = el)}
                    style={{
                      background:
                        image !== ""
                          ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
                          : data?.isPlaceHolder
                          ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #280B3F, #A985ED, #280B3F) border-box`
                          : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`,
                      borderRadius: "6px",
                      border: "1px solid transparent",
                      padding: "5px",
                      transition: " all 0.3s ",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #22BBBE, #7DAD41, #F4B719, #E55824, #B52C80) border-box`;
                    }}
                    onMouseLeave={(e) => {
                      // Revert only the background to the original state
                      e.currentTarget.style.background =
                        image !== ""
                          ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
                          : data?.isPlaceHolder
                          ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #280B3F, #A985ED, #280B3F) border-box`
                          : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`;
                    }}
                  >
                    {image === "" ? (
                      <div
                        className="img-block "
                        style={{
                          overflow: "hidden",
                          width: "100%",
                          background: data?.isPlaceHolder
                            ? "#280B3F"
                            : "#0B2A33",
                          border: data?.isPlaceHolder ? "#D8C2FF" : "#D8C2FF",
                        }}
                      >
                        <img
                          src={data?.isPlaceHolder ? Groupicon : GroupIconblue}
                          alt={
                            data?.isPlaceHolder
                              ? "Icon for #280B3F"
                              : "Icon for #0B2A33"
                          }
                        />
                      </div>
                    ) : (
                      <div
                        className="img-block p-0"
                        style={{ overflow: "hidden" }}
                      >
                        <img
                          style={{ width: "100%", height: "auto" }}
                          src={image}
                          alt=""
                        />
                      </div>
                    )}

                    <div className="text-block">
                      <label>
                        {data?.metadata == null
                          ? data.filename
                          : data?.metadata?.title == null
                          ? data.filename
                          : data?.metadata?.title}
                      </label>
                    </div>
                  </div>)
               
              })}
                </>
          :
          <NoData/>  
            }
          </div>
        </div>
      </div>
    </div>
  );
})

export default Videoplayer;
